import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { NHAPipesModule } from '@nha/pipes';
import { NHAFilterComponent } from './components/filter/filter.component';
import { NHAFiltersComponent } from './components/filters/filters.component';
import { NHASelectorComponent } from './components/selector/selector.component';
import { NHASelectorsComponent } from './components/selectors/selectors.component';
import * as fromFilters from './state';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { NHASelectedFilterChipComponent } from './components/selected-filter-chip/selected-filter-chip.component';
import { NHATagManagerModule } from '@nha/analytics/tag-manager.module';

export const FILTERS_COMPONENTS = [NHAFilterComponent, NHAFiltersComponent, NHASelectedFilterChipComponent, NHASelectorComponent, NHASelectorsComponent];

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		NHAPipesModule,
		MatButtonModule,
		MatMenuModule,
		MatChipsModule,
		MatIconModule,
		MatSidenavModule,
		MatSelectModule,
		FILTERS_COMPONENTS
	],
	providers: [fromFilters.FilterStateService, NHATagManagerModule],
	exports: [FILTERS_COMPONENTS]
})
export class NHAFiltersModule {}
